import React, { useEffect } from "react";
import { useFormContext, useFieldArray } from "react-hook-form";
import { PlusCircleIcon, MinusCircleIcon } from "@heroicons/react/24/outline";
import { Button } from "../../../../components/button";
import { TextInput } from "../../../../components/textInput/index";

const CheckpointChecklist = ({ label }) => {
  const {
    control,
    formState: { errors },
    register,
  } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "checklist_items",
  });

  return (
    <div className="sm:col-span-3 pt-2">
      <label
        htmlFor="first-name"
        className="block text-sm font-medium leading-6 text-gray-900 dark:text-gray-200"
      >
        {label}
      </label>

      {fields.map((field, index) => (
        <div className="flex w-full flex-col" key={field.id}>
          <div className="flex w-full items-center">
            <div className="flex-grow">
              <input
                type="hidden"
                {...register(`checklist_items[${index}].item_id`)}
              />
              <TextInput
                {...register(`checklist_items[${index}].item_text`)}
                placeholder="Checklist item"
              />
            </div>
            <Button
              variant="secondary"
              icon={MinusCircleIcon}
              aria-label="Remove item"
              onClick={() => remove(index)}
              className="ml-2"
            />
          </div>
          <p className="w-full mt-1 text-sm text-danger">
            {errors.checklist_items &&
              errors.checklist_items[index]?.item_text?.message}
          </p>
        </div>
      ))}

      <Button
        variant="secondary"
        icon={PlusCircleIcon}
        aria-label="Add a list item"
        onClick={() => append({ item_id: null, item_text: "" })}
        className="mt-2"
      />
    </div>
  );
};

export { CheckpointChecklist };
